"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLayerUpgradeError = void 0;
exports.upgradePageBlockLayers = upgradePageBlockLayers;
const page_connector_ends_1 = require("./page-connector-ends");
const page_document_maps_1 = require("./page-document-maps");
const page_layer_index_1 = require("./page-layer-index");
const page_part_directory_1 = require("./page-part-directory");
const page_structure_entry_1 = require("./page-structure-entry");
const page_upgrade_entry_1 = require("./page-upgrade-entry");
class PageLayerUpgradeError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'PageLayerUpgradeError';
    }
}
exports.PageLayerUpgradeError = PageLayerUpgradeError;
/**
 * Format 3 heads carry the canvas layer of blocks and the ends of connectors.
 * Format 2 was delivered only as one document; unshipped multipart data is
 * refused.
 */
function upgradePageBlockLayers(doc) {
    const map = (0, page_document_maps_1.pageStructureMap)(doc);
    const entries = new Map([...map].map(([id, value]) => {
        const entry = (0, page_upgrade_entry_1.readPageUpgradeEntry)(id, value);
        return [id, entry];
    }));
    if ([...(0, page_part_directory_1.readPagePartDirectory)(doc).keys()].some(id => id !== page_document_maps_1.PAGE_DOCUMENT_PART_ID))
        throw new PageLayerUpgradeError('Format 2 page contains unsupported content parts');
    const blocks = (0, page_document_maps_1.pagePartBlocksMap)(doc);
    const elements = (0, page_document_maps_1.pagePartElementsMap)(doc);
    const changes = [];
    for (const [id, entry] of entries) {
        if (entry.k === page_structure_entry_1.PAGE_CONNECTOR_KIND) {
            const fields = elements.get(id);
            if (!fields)
                throw new PageLayerUpgradeError('Missing connector fields: ' + id);
            changes.push([
                id,
                (0, page_structure_entry_1.encodePageStructureEntry)({
                    ...entry,
                    c: (0, page_connector_ends_1.readPageConnectorEnds)(id, fields),
                }),
            ]);
            continue;
        }
        const fields = blocks.get(id);
        const parentKind = entry.p === null ? undefined : entries.get(entry.p)?.k;
        if (!(0, page_layer_index_1.pageBlockInCanvasLayer)(entry.k, parentKind))
            continue;
        if (!fields)
            throw new PageLayerUpgradeError('Missing block fields: ' + id);
        if (!(0, page_layer_index_1.pageBlockUsesLayer)(id, entry.k, parentKind, {
            managedBy: fields.get('prop:managedBy'),
            visible: fields.get('prop:visible'),
            xywh: fields.get('prop:xywh'),
        })) {
            changes.push([id, (0, page_structure_entry_1.encodePageStructureEntry)({ ...entry, l: null })]);
            continue;
        }
        const layer = fields.get('prop:index');
        if (!(0, page_structure_entry_1.isFractionalIndex)(layer))
            throw new PageLayerUpgradeError('Missing or invalid canvas layer: ' + id);
        changes.push([id, (0, page_structure_entry_1.encodePageStructureEntry)({ ...entry, l: layer })]);
    }
    for (const [id, value] of changes)
        map.set(id, value);
}
